<template>
  <div>
    <px-lista-transportador-header :values="value"
                                   :max-select="maxSelect"
                                   @update="onChangeFilter"
                                   @reset="emitReset"/>
    <px-lista-transportador-list :transportadoras="transportadoras"
                                 :options-list="optionsList"
                                 :loading="loading"
                                 :max-select="maxSelect"
                                 v-model="localValue"
                                 :on-change-options="onChangeOptions"/>
  </div>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import TransportadorService from '../transportador-service';
import PxListaTransportadorList from './PxListaTransportadorList.vue';
import PxListaTransportadorHeader from './PxListaTransportadorHeader.vue';

export default {
  mixins: [paginationMixin],
  props: {
    value: Array,
    municipioColeta: Object,
    maxSelect: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      loading: false,
      filters: {},
      transportadoras: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      optionsList: {},
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    emitReset() {
      this.$emit('reset');
    },
    onChangeFilter(filters) {
      this.filters = filters;
      this.resetPage();
      this.getFornecedores();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getFornecedores();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getFornecedores() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      TransportadorService.list({
        limit,
        offset,
        query: this.buildFilter(),
      })
        .then(({ data }) => {
          this.transportadoras = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    joinFilter(filters) {
      return filters.filter(f => !!f)
        .join(' and ');
    },
    buildSearchText() {
      const cnpj = this.filters.searchText.replaceAll(/(\.)|(\/)|(-)/g, '');
      return `nome like "%${this.filters.searchText.toLowerCase()}%" or cnpj like "%${cnpj}%"`;
    },
    buildColetaFilter() {
      return `estadoColeta in (${this.municipioColeta.estado.id})`;
    },
    buildFilter() {
      const filters = [this.buildColetaFilter()];
      if (!this.filters) {
        return this.joinFilter(filters);
      }
      if (this.filters.searchText) {
        filters.push(this.buildSearchText());
      }
      return this.joinFilter(filters);
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    PxListaTransportadorList,
    PxListaTransportadorHeader,
  },
};
</script>
